import { ColliActionName } from '@frontend/colli/types';
import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import React from 'react';

import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import useColliActionSelect from '././colli-action-select.controller';

const ID = 'colli-action-select';
export interface ColliActionSelectProps extends Omit<SelectInputV2Props<ColliActionName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const ColliActionSelect = (props: ColliActionSelectProps) => {
    const viewProps = useColliActionSelect(props);

    return (
        <SelectInputV2<ColliActionName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Colli action'}
            options={viewProps.options}
        />
    );
};

export default ColliActionSelect;
